import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Laptop, DollarSign, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-white py-12 px-4" data-id="element-78">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-amber-50 via-white to-white opacity-80" data-id="element-79" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-7xl h-[500px] bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-80" />

      <div className="relative z-10 max-w-5xl mx-auto text-center" data-id="element-81">
        {/* Badge */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-50 border border-amber-200 text-amber-700 font-semibold text-sm mb-8" data-id="element-82">
          <span className="relative flex h-3 w-3" data-id="element-83">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-75" data-id="element-84"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-amber-500" data-id="element-85"></span>
          </span>
          Entrenamiento Online en Vivo
        </motion.div>

        {/* Featured Image - Square */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="mb-8 max-w-2xl mx-auto" data-id="element-86">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-87">
            <img src="https://res.cloudinary.com/dyxo8wdrc/image/upload/f_auto,q_auto/v1768233385/portada_cuadrada_Entrenamiento_Juega_Desde_Otro_Nivel_1_nuo1lp.jpg" alt="Juega desde Otro Nivel - Entrenamiento para líderes y vendedores" className="w-full h-auto object-cover" loading="eager" data-id="element-88" />
          </div>
        </motion.div>

        {/* Promise/Subtitle */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl md:text-2xl text-slate-700 max-w-3xl mx-auto mb-8 font-medium" data-id="element-89">
          Diseña tu plan de avance 2026 con resultados crecientes y sostenibles.
          <span className="block mt-2 text-slate-600 font-normal text-lg" data-id="element-90">
            Para líderes y vendedores de alto rendimiento.
          </span>
        </motion.p>

        {/* Event Details */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-wrap justify-center gap-4 md:gap-8 text-slate-700 mb-8" data-id="element-91">
          <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-slate-200 shadow-sm" data-id="element-92">
            <Calendar className="w-5 h-5 text-amber-500" data-id="element-93" />
            <span className="font-semibold" data-id="element-94">Martes 27 de Enero</span>
          </div>
          <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-slate-200 shadow-sm" data-id="element-95">
            <Laptop className="w-5 h-5 text-amber-500" data-id="element-96" />
            <span className="font-semibold" data-id="element-97">Online - En Vivo</span>
          </div>
          <div className="flex items-center gap-2 bg-white px-4 py-2 rounded-lg border border-slate-200 shadow-sm" data-id="element-98">
            <DollarSign className="w-5 h-5 text-amber-500" data-id="element-99" />
            <span className="font-semibold" data-id="element-100">Inversión: $15</span>
          </div>
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-101">
          <Button href="https://coneckta.co/taller-juegadesdeotronivel" size="xl" className="w-full md:w-auto min-w-[300px] shadow-xl hover:shadow-2xl" data-id="element-102">
            QUIERO JUGAR DESDE OTRO NIVEL
            <ArrowRight className="ml-2 w-6 h-6" data-id="element-103" />
          </Button>
          <p className="mt-4 text-sm text-slate-500" data-id="element-104">
            Sin motivación vacía. Sin improvisar. Estrategia pura.
          </p>
        </motion.div>
      </div>
    </section>;
}